import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";

const Unit = (props) => {

  return (
    <Fragment>
      <select className="unit" name="units" onChange = {props.computeGrades}>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
      </select>
    </Fragment>
  );
};

Unit.propTypes = {};

export default Unit;
